import type { DtoApplication } from "@porchpass/api-client";
import {
  getMainBorrowerIdFromApplication,
  getAuthBorrowerInfo,
} from "src/utils";
import type { DashboardInitializerParams } from "src/types/dashboard";
import {
  handleCoborrowerInviteRoute,
  handleMainBorrowerInviteRoute,
  handleRedirectParam,
  renderDashboard,
} from "./index";

export const setApplicationAndRouteUser = (
  response: DtoApplication[],
  {
    firebaseUser,
    setUserData,
    dealerName,
    navigate,
    setIsLoading,
    setApplications,
  }: DashboardInitializerParams,
) => {
  const application = response[0];
  const authBorrower = getAuthBorrowerInfo(application, firebaseUser);
  const mainBorrower = getMainBorrowerIdFromApplication(application);
  const { is_primary, status, id } = authBorrower;
  /**
   * Navigate user to expected redirect if:
   *  - @redirectParam matches DLA URL path format
   *  - Valid user on proper dealer site
   */
  const hasValidRedirectParam = handleRedirectParam(response, {
    setUserData,
    navigate,
    dealerName,
    firebaseUser,
  });
  if (hasValidRedirectParam) {
    return;
  }
  /**
   * Just return to Dashboard if user has multiple applications
   */
  if (response.length > 1) {
    renderDashboard(response, {
      setApplications,
      setIsLoading,
      navigate,
      dealerName,
    });
    return;
  }
  /**
   * Navigate invited applicant to the registration page if they have not yet accepted their invite
   */
  if (is_primary && status === "INVITED") {
    return handleMainBorrowerInviteRoute(
      application,
      authBorrower,
      mainBorrower,
      {
        setUserData,
        dealerName,
        navigate,
      },
    );
  }
  /**
   * Navigate coborrowers to the registration page if they have not yet accepted their invite
   */
  if (!is_primary && status === "INVITED" && id) {
    return handleCoborrowerInviteRoute(
      application,
      authBorrower,
      mainBorrower,
      { setUserData, navigate, dealerName },
    );
  }
  console.log("User has already registered.");
  /**
   * Else render dashboard
   */
  renderDashboard(response, {
    setIsLoading,
    navigate,
    setApplications,
    dealerName,
  });
};
